import datapoints from '../datapoints';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { userMailInteractionAction } from 'owa-mail-actions';
import { TableView } from 'owa-mail-list-store';
import { InstrumentationContext } from 'owa-mail-store';
import markAsJunkService from 'owa-mail-store/lib/services/markAsJunkService';
import reportMessageToSafetyLibraryService from 'owa-mail-triage-action/lib/services/reportMessageToSafetyLibraryService';
import * as undoActions from 'owa-mail-undo';
import SafetyApiAction from 'owa-service/lib/contract/SafetyApiAction';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';

/**
 * mark item as junk action
 * @param itemIds of the items to be marked as junk/not junk
 * @param isJunkValueToSet used to determine whether the item should be marked as junk
 * @param actionSource the action source where this action is triggered
 */
export default createLegacyActionWithDatapoint(
    'markItemsJunkNotJunkBasedOnItemIds',
    datapoints.markItemsJunkNotJunk
)(function markItemsJunkNotJunkBasedOnItemIds(
    itemIds: string[],
    isJunkValueToSet: boolean,
    actionSource: ActionSource,
    tableView: TableView,
    instrumentationContexts: InstrumentationContext[],
    markItemsJunkNotJunkStoreUpdate: () => void
) {
    undoActions.clearLastUndoableAction();

    const reportJunkEmailEnabledByAdmin = getUserConfiguration().SegmentationSettings
        .ReportJunkEmailEnabled;
    const reportJunkSelected = getUserConfiguration().UserOptions.ReportJunkSelected;
    const skipCheckForReportJunkDialog = getUserConfiguration().UserOptions
        .CheckForReportJunkDialog;
    let isChecked = false;

    try {
        if (
            // Add check for Message Safety Reporting after Bug 35457([OwaClientMessageSafetyReporting] disabled in React for EXO BlackForest, Gallatin and ITAR) is resolved
            isConsumer() ||
            (skipCheckForReportJunkDialog &&
                reportJunkSelected &&
                reportJunkEmailEnabledByAdmin &&
                isJunkValueToSet)
        ) {
            reportMessageToSafetyLibraryService(
                itemIds,
                isJunkValueToSet ? SafetyApiAction.Junk : SafetyApiAction.NotJunk
            );
        } else if (
            !reportJunkEmailEnabledByAdmin ||
            (skipCheckForReportJunkDialog && isJunkValueToSet)
        ) {
            markAsJunkService(itemIds, isJunkValueToSet);
        } else {
            //show dialog box
            confirm(
                isJunkValueToSet ? strings.reportAsJunk : strings.reportAsNotJunk,
                isConsumer
                    ? strings.reportJunkMessageBody
                    : strings.reportJunkMessageEnterpriseMessageBody,
                false,
                {
                    okText: strings.reportPhishing,
                    cancelText: strings.dontReportPhishing,
                    bodyElement: isJunkValueToSet ? (
                        <Checkbox
                            label={strings.ignore_dontShowAgainCheckbox}
                            onChange={() => {
                                isChecked = !isChecked;
                            }}
                        />
                    ) : null,
                }
            ).then((response: DialogResponse) => {
                if (isJunkValueToSet) {
                    const isReportJunkSelected = response === DialogResponse.ok;
                    getUserConfiguration().UserOptions.ReportJunkSelected = isReportJunkSelected;
                    getUserConfiguration().UserOptions.CheckForReportJunkDialog = isChecked;
                    updateUserConfiguration('OWA.UserOptions', [
                        userConfigurationDictionaryEntry({
                            DictionaryKey: userConfigurationDictionaryObject({
                                Type: 'String',
                                Value: ['CheckForReportJunkDialog'],
                            }),
                            DictionaryValue: userConfigurationDictionaryObject({
                                Type: 'Boolean',
                                Value: [String(isChecked)],
                            }),
                        }),
                        userConfigurationDictionaryEntry({
                            DictionaryKey: userConfigurationDictionaryObject({
                                Type: 'String',
                                Value: ['ReportJunkSelected'],
                            }),
                            DictionaryValue: userConfigurationDictionaryObject({
                                Type: 'Boolean',
                                Value: [String(isReportJunkSelected)],
                            }),
                        }),
                    ]);
                }
                if (response == DialogResponse.ok) {
                    reportMessageToSafetyLibraryService(
                        itemIds,
                        isJunkValueToSet ? SafetyApiAction.Junk : SafetyApiAction.NotJunk
                    );
                } else {
                    markAsJunkService(itemIds, isJunkValueToSet);
                }
            });
        }
    } catch (error) {
        // VSO 19006: Handle triage action service error
    }

    markItemsJunkNotJunkStoreUpdate();
    if (isJunkValueToSet) {
        userMailInteractionAction('MarkAsJunk', instrumentationContexts);
    }
});
